interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  titleAs?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  titleAs = "h2",
}: SectionHeadingProps) {
  const Tag = titleAs;
  return (
    <div
      className={`mb-8 flex flex-col gap-3 md:mb-10 ${
        align === "center" ? "items-center text-center" : "items-start"
      }`}
    >
      {eyebrow && (
        <span className="flex items-center gap-2 rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium tracking-wide text-accent-800">
          <i className="ri-sparkling-2-line text-sm"></i>
          {eyebrow}
        </span>
      )}
      <Tag className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </Tag>
      {desc && (
        <p
          className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${
            align === "center" ? "mx-auto" : ""
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}